import { Meta, theme } from 'aimo-ui';
import { Row } from 'components/longTermParking/styles';
import React from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import styled from 'styled-components/native';
import { ColumnWithMargins, RowSpaceBetween } from 'styles/ContainerStyles.ts';

type PermitElementRowProps = {
  label: string;
  detail: string | number;
  withBottomBorder?: boolean;
  withTopBorder?: boolean;
  borderColor?: string;
  icon?: React.ReactNode;
  onPress?: () => void;
  labelColor?: string;
  detailColor?: string;
  sublabel?: string;
};

const Shrink = styled.View`
  flex-shrink: 1;
`;

export const PermitElementRow = ({
  label,
  detail,
  withBottomBorder = false,
  withTopBorder = false,
  borderColor,
  icon,
  onPress,
  labelColor,
  detailColor,
  sublabel,
}: PermitElementRowProps) => {
  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <RowSpaceBetween
        padding={15}
        withTopBorder={withTopBorder}
        withBottomBorder={withBottomBorder}
        borderColor={borderColor}>
        <ColumnWithMargins maxWidth="60%">
          <Meta
            color={labelColor ?? theme.colors.gray300}
            numberOfLines={1}
            ellipsizeMode="tail">
            {label}
          </Meta>
          {sublabel && (
            <Meta
              color={labelColor ?? theme.colors.gray300}
              numberOfLines={1}
              ellipsizeMode="tail">
              {sublabel}
            </Meta>
          )}
        </ColumnWithMargins>
        <Shrink>
          <Row justify="space-between">
            {detail && <Meta color={detailColor}>{detail}</Meta>}
            {icon}
          </Row>
        </Shrink>
      </RowSpaceBetween>
    </TouchableWithoutFeedback>
  );
};
